import { render } from "./OrganizationStructure.vue?vue&type=template&id=81435292&scoped=true"
import script from "./OrganizationStructure.vue?vue&type=script&lang=js"
export * from "./OrganizationStructure.vue?vue&type=script&lang=js"

import "./OrganizationStructure.vue?vue&type=style&index=0&id=81435292&scoped=true&lang=less"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81435292"]])

export default __exports__